import { httpService } from 'core-utilities';
import { getWelcomeDevexUrlConfig } from '../constants/developerExchangeWelcomeMessageConstants';

const getWelcomeDevexMetaData = () => {
  const urlConfig = getWelcomeDevexUrlConfig();
  return httpService.get(urlConfig);
};

export default getWelcomeDevexMetaData;
